import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NetworkConnectionComponent } from './network-connection.component';
import { NetworkConnectionService } from './network-connection.service';



@NgModule({
    declarations: [
        NetworkConnectionComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NetworkConnectionComponent
    ],
    providers: [
        NetworkConnectionService
    ]
})
export class NetworkConnectionModule { }
